<template>
  <tr>
    <td>
      <span class="fs-13">{{ size.name }}</span></td>
    <td>
      <span v-if="!isNaN(getUnitPrice)" class="fs-13">{{ getUnitPrice | toPrice(2, '€') }}</span>
      <span v-else class="fs-13">N/R</span>
    </td>
    <td>
      <v-row
        display="flex"
        justify="center"
        align="center"
      >
        <v-btn 
          fab 
          x-small 
          dark 
          color="primary"
          @click.stop="rmvQty"
          :disabled="isNaN(getUnitPrice)"
          class="rmv-qty"
        >
          <v-icon>mdi-minus</v-icon>
        </v-btn>
        <v-text-field
          dense
          type="number"
          class="pt-2 mb-0 flex-shrink-3 input-qty"
          :sizeId="size.id"
          style="width: 60px"
          v-model="quantity"
          min=0
          @input="changeQty"
          :disabled="isNaN(getUnitPrice)"
        ></v-text-field>
        <v-btn 
          fab 
          x-small 
          dark 
          color="primary"
          @click.stop="addQty"
          :disabled="isNaN(getUnitPrice)"
          class="add-qty"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-row>
    </td>
  </tr>
</template>

<script>
  // EVENTS
  import { EventBus } from '@/main.js'
  import { REMOVE_FROM_TMP_CART, ADD_TO_TMP_CART, ADD_TO_CART, UPDATE_PRICE } from '@/store/actions/cart'
  // MIXINS
  import utils from '@/mixins/utils'

  export default {
    name: 'Row',

    mixins: [utils],

    data: () => ({
      quantity: 0,
      unitPrice: 0,
      discount: null,
    }),

    props: {
      reference: Object,
      color: Object,
      size: Object,
    },

    computed: {
      getUnitPrice() {
        if (this.discount !== null) {
          return this.unitPrice * (1 - (this.discount / 100))
        }

        return this.unitPrice
      },
    },

    methods: {
      changeQty() {
        let item = {}
        let fn = ''
        if (this.quantity == 0) {
          item = {
            reference: this.reference.id,
            color: this.color.id,
            size: this.size.id,
          }
          fn = REMOVE_FROM_TMP_CART
        } else {
          item = {
            id: this.getUniqueId(),
            reference: {
              id: this.reference.id,
              exRef: this.reference.exRef,
              name: this.reference.name,
              thumbnail: this.reference.thumbnail,
              description: this.reference.description,
              defaultProduct: {
                id: this.reference.defaultProduct.id,
                name: this.reference.defaultProduct.name,
              },
            },
            color: this.color,
            size: this.size,
            quantity: this.quantity,
            unitPrice: this.unitPrice,
            discount: this.discount,
            getUnitPrice() {
              if (this.discount !== null) {
                return parseFloat(this.unitPrice * (1 - (this.discount / 100)))
              }

              return parseFloat(this.unitPrice)
            }
          }
          fn = ADD_TO_TMP_CART
        }
        this.$store.commit(fn, item)
      },
      rmvQty() {
        if (this.quantity > 0) {
          this.quantity--
        }
        this.changeQty()
      },
      addQty() {
        this.quantity++
        this.changeQty()
      }
    },

    mounted() {
      EventBus.$on(ADD_TO_CART, () => {
        if (this.quantity > 0) {
          let item = {
            id: this.getUniqueId(),
            reference: {
              id: this.reference.id,
              exRef: this.reference.exRef,
              name: this.reference.name,
              thumbnail: this.reference.thumbnail,
              description: this.reference.description,
              defaultProduct: {
                id: this.reference.defaultProduct.id,
                name: this.reference.defaultProduct.name,
              },
            },
            color: this.color,
            size: this.size,
            quantity: parseInt(this.quantity),
            unitPrice: parseFloat(this.unitPrice),
            discount: this.discount,
            getUnitPrice() {
              if (this.discount !== null) {
                return parseFloat(this.unitPrice * (1 - (this.discount / 100)))
              }

              return parseFloat(this.unitPrice)
            }
          }
          this.$store.dispatch(ADD_TO_CART, item)
          this.quantity = 0
        }
      })
      EventBus.$on(UPDATE_PRICE, (prices) => {
        this.unitPrice = prices[this.size.id]
        if (this.$store.getters.getDiscount !== null) {
          this.discount = this.$store.getters.getDiscount
        }
        this.quantity  = 0
      })
    }
  }
</script>

<style>
  .fs-13 {
    font-size: 13px !important;
  }
  .v-text-field {
    flex: 0 1 auto;
    margin-left: 20px;
    margin-right: 20px;
  }
  input[sizeid] {
    text-align: center !important;
  }
</style>